import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["status"]
    static values = { delay: { type: Number, default: 500 } }

    connect() {
        this.submitTimeout = null
        this.statusTimeout = null
    }

    disconnect() {
        clearTimeout(this.submitTimeout)
        clearTimeout(this.statusTimeout)
    }

    queue() {
        clearTimeout(this.submitTimeout)

        if (!this.element.reportValidity()) {
            this.clearStatus()
            return
        }

        this.setStatus("Updating...")
        this.submitTimeout = setTimeout(() => this.submit(), this.delayValue)
    }

    submit() {
        clearTimeout(this.submitTimeout)

        if (!this.element.reportValidity()) return

        this.element.requestSubmit()
    }

    submitting() {
        this.setStatus("Updating...")
    }

    submitted(event) {
        if (event.detail.success) {
            this.setStatus("Updated")
            clearTimeout(this.statusTimeout)
            this.statusTimeout = setTimeout(() => this.clearStatus(), 1200)
            return
        }

        this.setStatus("Couldn't update")
    }

    setStatus(message) {
        if (!this.hasStatusTarget) return

        this.statusTarget.textContent = message
    }

    clearStatus() {
        if (!this.hasStatusTarget) return

        this.statusTarget.textContent = ""
    }
}
